export default __webpack_public_path__ + "static/media/nicotina-bg-desktop.4b883817.jpg";